module.exports = __webpack_public_path__ + "images/花筑村全景_06-4.jpg?v=b8017ed0";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-4.jpg
 ** module id = 96
 ** module chunks = 1 2
 **/